import { render } from "./ContactUs.vue?vue&type=template&id=7962cc55&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=7962cc55&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7962cc55"

export default script